import React from "react";

function EditIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="4" fill="#F3F3F5" />
      <rect width="26" height="26" rx="4" fill="#F3F3F5" />
      <g clipPath="url(#clip0_149_589)">
        <rect
          width="16"
          height="16"
          transform="translate(5 5)"
          fill="#F3F3F5"
        />
        <path
          d="M12.3333 7.66665H7.66659C7.31296 7.66665 6.97382 7.80713 6.72378 8.05718C6.47373 8.30723 6.33325 8.64637 6.33325 8.99999V18.3333C6.33325 18.6869 6.47373 19.0261 6.72378 19.2761C6.97382 19.5262 7.31296 19.6667 7.66659 19.6667H16.9999C17.3535 19.6667 17.6927 19.5262 17.9427 19.2761C18.1928 19.0261 18.3333 18.6869 18.3333 18.3333V13.6667M17.3333 6.66665C17.5985 6.40144 17.9582 6.25244 18.3333 6.25244C18.7083 6.25244 19.068 6.40144 19.3333 6.66665C19.5985 6.93187 19.7475 7.29158 19.7475 7.66665C19.7475 8.04173 19.5985 8.40144 19.3333 8.66665L12.9999 15L10.3333 15.6667L10.9999 13L17.3333 6.66665Z"
          stroke="#1E1E1E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_149_589">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default EditIcon;
